module.exports = __webpack_public_path__ + "static/img/map.25b11f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/map.jpg
// module id = e2cG
// module chunks = 18